import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	atlas: {
		id: 'dynamic-cards-search-page.products.atlas',
		defaultMessage: 'Atlas',
		description: 'Product name for Atlas',
	},
	webPage: {
		id: 'dynamic-cards-search-page.products.custom-website',
		defaultMessage: 'Web page',
		description: 'display name for Web page',
	},
	webPages: {
		id: 'dynamic-cards-search-page.products.custom-websites',
		defaultMessage: 'Web pages',
		description: 'display name for Web pages',
	},
	project: {
		id: 'dynamic-cards-search-page.nouns.project',
		defaultMessage: 'Project',
		description: 'display name for Project',
	},
	projects: {
		id: 'dynamic-cards-search-page.nouns.projects',
		defaultMessage: 'Projects',
		description: 'display name for Projects',
	},
	goal: {
		id: 'dynamic-cards-search-page.nouns.goal',
		defaultMessage: 'Goal',
		description: 'display name for Goal',
	},
	goals: {
		id: 'dynamic-cards-search-page.nouns.goals',
		defaultMessage: 'Goals',
		description: 'display name for Goals',
	},
	tag: {
		id: 'dynamic-cards-search-page.nouns.tag',
		defaultMessage: 'Tag',
		description: 'display name for Tag',
	},
	tags: {
		id: 'dynamic-cards-search-page.nouns.tags',
		defaultMessage: 'Tags',
		description: 'display name for Tags',
	},
});
